import Utils from '../utils';

//User Dashboard Revamp
export const transactionHistoryRoute = {
  path: '/transaction-history',
  component: 'dashboard',
  componentName: 'Dashboard',
  theme: 'instaCred',
  template: 'home',
  authenticated: true,
  isIdentifyUserRoute: true,
};
export const alltransactionPageRoute = {
  path: '/transaction-history/all-transaction-list',
  internalRoute: '/transaction-history/',
  component: 'all-transaction-list',
  componentName: 'All Transaction List',
  theme: 'instaCred',
  template: 'home',
  isIdentifyUserRoute: true,
};

export const buyWithInstacredLandingRoute = {
  path: '/buy',
  component: 'buy-with-instacred-landing',
  componentName: 'Buy With InstaCred',
  theme: 'instaCred',
  template: 'home',
  isIdentifyUserRoute: true,
};

export const buyWithInstacredLandingSearch = {
  path: '/search',
  component: 'bicSearch',
  componentName: 'Buy With InstaCred Search',
  theme: 'instaCred',
  template: 'home',
};

//I don't think this path is getting used at all
export const buyWithInstacredMerchantLandingPageRoute = {
  path: '/buy/:merchantHandle',
  component: 'buy-with-instacred-landing',
  componentName: 'Buy With InstaCred',
  theme: 'instaCred',
  template: 'home',
};

export const buyWithInstacredLandingPageSymlinkRoute = {
  path: '/home/buy-with-instacred',
  component: 'buy-with-instacred-landing',
  componentName: 'Buy With InstaCred',
  theme: 'instaCred',
  template: 'home',
  isIdentifyUserRoute: true,
};

export const offersRoute = {
  path: '/offers',
  component: 'offers',
  componentName: 'Offers',
  theme: 'instaCred',
  template: 'home',
};

export const howToBuyRoute = {
  path: '/how-to-buy/:handle',
  internalRoute: '/how-to-buy/',
  component: 'how-to-buy',
  componentName: 'How To Buy',
  theme: 'instaCred',
  template: 'home',
};

export const howToBuyProductRoute = {
  path: '/product/:handle/:productId',
  internalRoute: '/product/',
  component: 'how-to-buy-product',
  componentName: 'How To Buy Product',
  theme: 'instaCred',
  template: 'home',
};

export const voucherPageRoute = {
  path: '/voucher/:merchantName',
  component: 'voucher',
  componentName: 'Voucher',
  theme: 'instaCred',
  template: 'home',
};

export const faqRoute = {
  path: '/faq',
  component: 'faq',
  componentName: 'FAQ',
  theme: 'instaCred',
  template: 'home',
};

export const ntbFaqRoute = {
  path: '/new-user-faq',
  component: 'ntb-faq',
  componentName: 'NtbFAQ',
  theme: 'instaCred',
  template: 'common',
};

export const benowFaqRoute = {
  path: '/benow-faq',
  component: 'benow-faq',
  componentName: 'BenowFaq',
  theme: 'instaCred',
  template: 'common',
};

export const worldLineFaqRoute = {
  path: '/worldline-faq',
  component: 'worldline-faq',
  componentName: 'WorldLineFaq',
  theme: 'instaCred',
  template: 'common',
};

export const loginRoute = Utils.isOrganicSite()
  ? {
      path: '/account',
      component: 'account',
      componentName: 'Account',
      theme: 'instaCred',
      template: 'account',
      isIdentifyUserRoute: true,
    }
  : {
      path: '/login',
      component: 'login',
      componentName: 'Enter Mobile',
      theme: 'instaCred',
      template: 'login',
      isIdentifyUserRoute: true,
    };

export const affiliateMerchantRoute = {
  path: '/affiliate/amazon',
  component: 'merchant-affiliate',
  componentName: 'Merchant Affiliate',
  theme: 'instaCred',
  template: 'home',
};

//Campaign activation landing page
export const campaignUserActivationLandingPageRoute = {
  path: '/campaign-user-activation',
  component: 'campaign-activation',
  componentName: 'Campaign Activation Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbCampaignUserActivationLandingPageRoute = {
  path: '/new-origination/merchant',
  component: 'ntb-campaign-activation',
  componentName: 'Ntb Campaign Activation Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbCampaignFailurePageRoute = {
  path: '/new-origination/merchant/failure',
  component: 'ntb-campaign-failure',
  componentName: 'Ntb Campaign Failure Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbCampaignUserNotEligiblePageRoute = {
  path: '/new-origination/merchant/user-not-eligible',
  component: 'ntb-campaign-user-not-eligible',
  componentName: 'Ntb Campaign User Not Eligible Page',
  theme: 'instaCred',
  template: 'common',
};

export const campaignUserActivationPreapprovedSuccessPageRoute = {
  path: '/campaign-preapproved-user-activation-success',
  component: 'campaign-preapproved-success',
  componentName: 'Campaign Preapproved User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const campaignUserNotEligible = {
  path: '/campaign-user-not-eligible',
  component: 'campaign-user-not-eligible',
  componentName: 'Campaign User not Eligible Page',
  theme: 'instaCred',
  template: 'common',
};

//OfflineStores landing page
export const offlineStoresLandingPageRoute = {
  path: '/check',
  component: 'offline-stores',
  componentName: 'Offline Stores Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const offlineStoresEligibilePageRoute = {
  path: '/check-user-activation-success',
  component: 'offline-stores-preapproved',
  componentName: 'Offline Stores User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const offlineStoresNotEligibleRoute = {
  path: '/check-user-not-eligible',
  component: 'offline-stores-not-eligible',
  componentName: 'Offline Stores not eligible screen',
  theme: 'instaCred',
  template: 'common',
};

//benow check landing page
export const benowLandingPageRoute = {
  path: '/benow-check',
  component: 'benow-check',
  componentName: 'Benow Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const benowEligibilePageRoute = {
  path: '/benow-check-user-activation-success',
  component: 'benow-preapproved',
  componentName: 'Benow User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const benowNotEligibleRoute = {
  path: '/benow-check-user-not-eligible',
  component: 'benow-nonapproved',
  componentName: 'Benow not eligible screen',
  theme: 'instaCred',
  template: 'common',
};

//lotmobilea check landing page
export const lotMobilesLandingPageRoute = {
  path: '/lotmobiles',
  component: 'lotmobiles-check',
  componentName: 'LotMobiles Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const lotMobilesEligibilePageRoute = {
  path: '/lotmobiles-user-activation-success',
  component: 'lotmobiles-preapproved',
  componentName: 'LotMobiles User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const lotMobilesNotEligibleRoute = {
  path: '/lotmobiles-user-not-eligible',
  component: 'lotmobiles-nonapproved',
  componentName: 'LotMobiles not eligible screen',
  theme: 'instaCred',
  template: 'common',
};

//bigc check landing page
export const bigcLandingPageRoute = {
  path: '/bigcmobiles',
  component: 'bigc-check',
  componentName: 'BigcMobiles Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const bigcEligibilePageRoute = {
  path: '/bigcmobiles-user-activation-success',
  component: 'bigc-preapproved',
  componentName: 'BigcMobiles User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const bigcNotEligibleRoute = {
  path: '/bigcmobiles-check-user-not-eligible',
  component: 'bigcmobiles-nonapproved',
  componentName: 'BigcMobiles not eligible screen',
  theme: 'instaCred',
  template: 'common',
};

//Program Landing Page
export const programLandingPageRoute = {
  path: '/instacred-cardless-emi/:type?',
  component: 'program-landing-page',
  componentName: 'Program Landing Page',
  theme: 'instaCred',
  template: 'common',
};

export const programLandingPageDefaultRoute = {
  path: '/instacred-cardless-emi',
  component: 'program-landing-page',
  componentName: 'Program Landing Page',
  theme: 'instaCred',
  template: 'common',
};

//NTB program pages

export const ntbProgramSuccessRoute = {
  path: '/ntb-preapproved-success',
  component: 'program-ntb-preapproved',
  componentName: 'NTB Program Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbProgramNonApprovedRoute = {
  path: '/ntb-nonapproved',
  component: 'program-ntb-nonapproved',
  componentName: 'NTB Program Non Approved Page',
  theme: 'instaCred',
  template: 'common',
};
//NTB Activation Landing Page
export const newUserActivationLandingPageRoute = {
  path: '/new-user-activation',
  component: 'ntb-activation',
  componentName: 'New User Activation Landing Page',
  theme: 'instaCred',
  template: 'common',
};
export const newUserActivationSuccessPageRoute = {
  path: '/new-user-activation-success',
  component: 'ntb-registration-success',
  componentName: 'New User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const newUserActivationPreapprovedSuccessPageRoute = {
  path: '/preapproved-user-activation-success',
  component: 'ntb-preapproved-success',
  componentName: 'Preapproved User Activation Success Page',
  theme: 'instaCred',
  template: 'common',
};

export const ntbStatusRoute = {
  path: '/ntb-status',
  component: 'ntb-approved-rejected-status',
  componentName: 'Ntb approved rejected status',
  theme: 'instaCred',
  template: 'ntb',
};

export const ntbLenderRedirectionRoute = {
  path: '/ntb-lender-redirection',
  component: 'ntb-lender-redirection',
  componentName: 'Ntb Lender Redirection',
  theme: 'instaCred',
  template: 'neutral',
};

export const linkTabRedirectionRoute = {
  path: '/tab-redirection',
  component: 'tab-redirection',
  componentName: 'Tab Redirection',
  theme: 'instaCred',
  template: 'neutral',
};

export const ntbApplicationRoute = {
  path: '/ntb-application',
  component: 'ntb-application',
  componentName: 'Ntb flow application',
  theme: 'instaCred',
  template: 'common',
};

export const vouchersVijaySalesRoute = {
  path: '/vouchers-vijaysales',
  component: 'vouchers-vijaysales',
  componentName: 'Vouchers Landing Page Vijay Sales',
  theme: 'instaCred',
  template: 'common',
};

export const vouchersInstacredRoute = {
  path: '/vouchers-instacred',
  component: 'vouchers-instacred',
  componentName: 'Vouchers Landing Page Instacred',
  theme: 'instaCred',
  template: 'common',
};

export const nocostZebrs = {
  path: '/offers-zebrs',
  component: 'offers-zebrs',
  componentName: 'Offers Landing Page Zebrs',
  theme: 'instaCred',
  template: 'common',
};
export const offersLotMobiles = {
  path: '/offers-lotmobiles',
  component: 'offers-lotmobiles',
  componentName: 'Offers Landing Page Lot Mobiles',
  theme: 'instaCred',
  template: 'common',
};
export const offersMdComputers = {
  path: '/offers-mdcomputers',
  component: 'offers-mdcomputers',
  componentName: 'Offers Landing Page MD Computers',
  theme: 'instaCred',
  template: 'common',
};
export const contactUsRoute = {
  path: '/odr/contact-us',
  component: 'odr/contactUs',
  componentName: 'Contact Us',
  theme: 'instaCred',
  template: 'oldHome',
  isIdentifyUserRoute: true,
};

export const viewTicketRoute = {
  path: '/odr/view-ticket',
  component: 'odr/viewTicket',
  componentName: 'Ticket Status',
  theme: 'instaCred',
  template: 'oldHome',
};

export const confirmationScreenRoute = {
  path: '/odr/confirmation-screen',
  component: 'odr/confirmationScreen',
  componentName: 'Confirmation Screen',
  theme: 'instaCred',
  template: 'oldHome',
};

export const contactUsGuidelinesRoute = {
  path: '/odr/contact-us-guidelines',
  component: 'odr/contactUsGuidelines',
  componentName: 'Contact Us Guidelines',
  theme: 'instaCred',
  template: 'oldHome',
};

export const offersNilkamal = {
  path: '/offers-nilkamal',
  component: 'offers-nilkamal',
  componentName: 'Offers Landing Page Nilkamal',
  theme: 'instaCred',
  template: 'common',
};
export const offersDoctorDreams = {
  path: '/offers-doctordreams',
  component: 'offers-doctordreams',
  componentName: 'Offers Landing Page DoctorDreams',
  theme: 'instaCred',
  template: 'common',
};
export const offersBigC = {
  path: '/offers-bigc',
  component: 'offers-bigc',
  componentName: 'Offers Landing Page BigC',
  theme: 'instaCred',
  template: 'common',
};

export const offersInstacred = {
  path: '/offers-instacred',
  component: 'offers-instacred',
  componentName: 'Offers Landing Page Instacred',
  theme: 'instaCred',
  template: 'home',
};

export const offersEmiBaba = {
  path: '/offers-emibaba',
  component: 'offers-emibaba',
  componentName: 'Offers Landing Page Emi Baba',
  theme: 'instaCred',
  template: 'common',
};

export const bicRevampCategoryPage = {
  path: '/category',
  component: 'bic-revamp-category',
  componentName: 'Bic Revamp Category',
  theme: 'instaCred',
  template: 'common',
};
export const bicRevampCategoryViewAllPage = {
  path: '/category-all',
  component: 'category-view-all',
  componentName: 'Category View All',
  theme: 'instaCred',
  template: 'home',
};
export const brandDetailsPage = {
  path: '/brand',
  component: 'brand-details-page',
  componentName: 'Brand Details Page',
  theme: 'instaCred',
  template: 'common',
};
export const offersSleepyhead = {
  path: '/offers-sleepyhead',
  component: 'offers-sleepyhead',
  componentName: 'Offers Landing Page Sleepyhead',
  theme: 'instaCred',
  template: 'common',
};

export const redirect = {
  path: '/redirect/',
  component: 'redirect',
  componentName: 'Redirect',
  theme: 'instaCred',
  template: 'common',
};

export const offersPepperFry = {
  path: '/offers-pepperfry',
  component: 'offers-pepperfry',
  componentName: 'Offers Landing Page Pepperfry',
  theme: 'instaCred',
  template: 'common',
};
export const offersSangeethaMobiles = {
  path: '/offers-sangeetha-mobiles',
  component: 'offers-sangeethaMobiles',
  componentName: 'Offers Landing Page Sangeetha Mobiles',
  theme: 'instaCred',
  template: 'common',
};

export const allBrandsPage = {
  path: '/brands',
  component: 'all-brands',
  componentName: 'All brands page',
  theme: 'instaCred',
  template: 'common',
};

export const instacredHomeRoutes = [
  alltransactionPageRoute,
  buyWithInstacredLandingRoute,
  buyWithInstacredLandingSearch,
  buyWithInstacredMerchantLandingPageRoute,
  buyWithInstacredLandingPageSymlinkRoute,
  offersRoute,
  howToBuyRoute,
  voucherPageRoute,
  faqRoute,
  ntbFaqRoute,
  benowFaqRoute,
  worldLineFaqRoute,
  loginRoute,
  transactionHistoryRoute,
  affiliateMerchantRoute,
  campaignUserActivationLandingPageRoute,
  ntbCampaignUserActivationLandingPageRoute,
  campaignUserActivationPreapprovedSuccessPageRoute,
  campaignUserNotEligible,
  newUserActivationLandingPageRoute,
  newUserActivationSuccessPageRoute,
  newUserActivationPreapprovedSuccessPageRoute,
  ntbStatusRoute,
  ntbApplicationRoute,
  offlineStoresLandingPageRoute,
  offlineStoresEligibilePageRoute,
  offlineStoresNotEligibleRoute,
  programLandingPageRoute,
  programLandingPageDefaultRoute,
  ntbProgramSuccessRoute,
  ntbProgramNonApprovedRoute,
  vouchersVijaySalesRoute,
  vouchersInstacredRoute,
  nocostZebrs,
  offersLotMobiles,
  offersMdComputers,
  contactUsRoute,
  viewTicketRoute,
  confirmationScreenRoute,
  contactUsGuidelinesRoute,
  offersNilkamal,
  offersDoctorDreams,
  offersBigC,
  offersInstacred,
  offersEmiBaba,
  bicRevampCategoryPage,
  brandDetailsPage,
  offersSleepyhead,
  offersSangeethaMobiles,
  redirect,
  offersPepperFry,
  benowLandingPageRoute,
  benowEligibilePageRoute,
  benowNotEligibleRoute,
  bicRevampCategoryViewAllPage,
  lotMobilesLandingPageRoute,
  lotMobilesEligibilePageRoute,
  lotMobilesNotEligibleRoute,
  bigcLandingPageRoute,
  bigcEligibilePageRoute,
  bigcNotEligibleRoute,
  howToBuyProductRoute,
  allBrandsPage,
  ntbCampaignUserNotEligiblePageRoute,
  ntbLenderRedirectionRoute,
  ntbCampaignFailurePageRoute,
  linkTabRedirectionRoute,
];



// WEBPACK FOOTER //
// ./alias/homeRoutes.js